import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-step-five',
  templateUrl: './step-five.component.html',
  styleUrls: ['./step-five.component.scss']
})
export class StepFiveComponent implements OnInit {

  isLoading: boolean = false;

  pageTitle: string;
  title: string;
  description: string;
  files: File[] = [];
  youtube: string;
  routeId = JSON.parse(localStorage.getItem('currentRouteId'));
  currentRoute = JSON.parse(localStorage.getItem('userRoutes')).find(id => id.id === this.routeId);

  constructor(private apiService: ApiService, private router: Router, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.currentRoute = JSON.parse(localStorage.getItem('userRoutes')).find(id => id.id === this.routeId);
    this.pageTitle = 'Édition du circuit ' + this.currentRoute.title;
    this.title = this.currentRoute.title;
    this.description = this.currentRoute.description;
    this.youtube = this.currentRoute.youtube;
    if (this.currentRoute.medias.length) {
      this.currentRoute.medias.forEach((element, index) => {
        let format = element.url.substring(element.url.lastIndexOf('.') + 1);
        let name = element.url.substring(element.url.lastIndexOf('/') + 1);
        let file = dataURLtoFile('data:image/' + format + ';base64,' + element.data, name);
        this.files.push(file);
      });
    }
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  validateRoute() {
    this.isLoading = true;

    this.apiService.addRoute('fr_FR', this.title, {route_id: this.routeId, description: this.description, youtube: this.youtube, medias: this.files, etat: '2'}).subscribe(
      data => {
        document.querySelector(".create-circuit").scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.isLoading = false;
        this.toastr.success('Circuit publié ! Vous allez être redirigé vers la page des circuits dans 5 secondes.', 'Bravo !', {
          timeOut: 5000,
        });
        this.redirectToHome();
      },
      err => {
        console.log(err);
      }
    );
  }

  redirectToHome() {
    setTimeout(() => {
      this.router.navigate(['/circuits']);
    }, 5000);
  }

}


function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
  mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]),
  n = bstr.length,
  u8arr = new Uint8Array(n);

  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, {type:mime});
}
